import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=1effb4b6"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/TypXw3yGP/0/DHCCorporation/dhc-cloud-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1effb4b6')) {
      api.createRecord('1effb4b6', component.options)
    } else {
      api.reload('1effb4b6', component.options)
    }
    module.hot.accept("./ChangePassword.vue?vue&type=template&id=1effb4b6", function () {
      api.rerender('1effb4b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ChangePassword.vue"
export default component.exports